import { computed, type ComputedRef } from "vue";
import { session } from "./session";

/** The company open in this tab, for screens that call its API (/v1/c/:slug/...). */
export function useSlug(): ComputedRef<string> {
  return computed(() => session.slug);
}
